var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonaciones(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "66px",
    viewBox: "0 0 60 66",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Donaciones") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-2",
    transform: "translate(-633.000000, -7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Donaciones",
    transform: "translate(633.000000, 7.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Regalo"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#E5EBEF",
    points: "2.29375 66 57.4475 66 57.4475 15.1960374 2.29375 15.1960374"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#E5EBEF",
    points: "0 29.7129533 59.73875 29.7129533 59.73875 15.1960374 0 15.1960374"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#FF543C",
    points: "38.6780625 -6.16822435e-05 29.8693125 14.3657327 30.7893125 15.1959757 44.4761875 5.21948972"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#FF543C",
    points: "21.0605625 -6.16822435e-05 15.2636875 5.21948972 28.9493125 15.1959757 29.8693125 14.3657327"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#FF7057",
    points: "30.7898125 15.1958523 50.4160625 13.8826374 48.0641875 5.23910467 30.4148125 13.8209551"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FF7057",
    points: "28.9489375 15.1958523 9.3226875 13.8826374 11.6808125 5.23910467 29.3239375 13.8209551"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#FF543C",
    points: "32.243625 15.0970991 30.789875 15.1957907 28.94925 15.1957907 27.494875 15.0970991 28.30675 11.8168374 31.4355 11.8168374"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FF7057",
    points: "28.03375 29.7129533 31.709375 29.7129533 31.709375 15.1960374 28.03375 15.1960374"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#FF543C",
    points: "28.033125 66 31.709375 66 31.709375 29.7129533 28.033125 29.7129533"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#FF7057",
    points: "2.29375 38.2084486 57.4475 38.2084486 57.4475 34.5784486 2.29375 34.5784486"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#CCD4DC",
    points: "2.29375 31.4505421 57.4475 31.4505421 57.4475 29.7129533 2.29375 29.7129533"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#FF543C",
    points: "41.04 24.4030374 31.70875 15.195729 28.033125 15.195729 18.70125 24.4030374 21.30125 26.9684019 29.870625 18.5099159 38.44 26.9684019"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonaciones);
export default __webpack_public_path__ + "static/media/donaciones.d8adbebf5f1c01c75ea758a3301eb7d3.svg";
export { ForwardRef as ReactComponent };